import { type ISeriesAssociation } from '@/types/series.types';
import { Post } from '../helpers';
import { SeriesPath } from './path';

export default function AddEventToSeries({
  channel,
  seriesUuid,
  eventUuid,
}: {
  channel: number;
  seriesUuid: string;
  eventUuid: string;
}) {
  return Post<ISeriesAssociation>({
    path: SeriesPath(channel, `/${seriesUuid}/events/${eventUuid}`),
  });
}
